import { useResolvedAccessLevel } from '../../components/PermissionsContainer';

/**
 * Component id for the order-level Railbill Y/N flag gate.
 *
 * Unlike the Haz flag (which lives in the order-lc-fields grouping), the Railbill
 * flag is edited by DISPATCHERS, so it gets its own component permission — an
 * admin grants a dispatcher group edit access on `railbill-flag` independently of
 * the LC field gate.
 */
export const RAILBILL_FIELD_COMPONENT_ID = 'railbill-flag';

/**
 * Whether the current user may edit the order's Railbill Y/N flag.
 *
 * Resolved from the admin-configured component permission crossed with the
 * user's Azure AD groups. Ships **defaultDisabled**: until an admin grants a
 * group edit access on `railbill-flag`, the flag stays read-only for everyone.
 */
export const useCanEditRailbillField = (): boolean =>
  useResolvedAccessLevel(RAILBILL_FIELD_COMPONENT_ID, false, true) >= 2;
